import { cloneDeep, includes } from 'lodash';

import { ColumnsSettingsViewDict } from '../typings/common';
import { GoalDecl } from '../typings/goals';

import { arrangeInOrder } from './DeclarationHelper';

export function getColumnsVisibilitySettings(
    settings: ColumnsSettingsViewDict,
    enabledKeys: string[],
    view: string
): ColumnsSettingsViewDict {
    const columnsSettings = cloneDeep(settings);

    if (!columnsSettings[view]) {
        throw `No column settings for ${view}`;
    }

    Object.keys(columnsSettings[view].columnViewInfo).forEach(columnKey => {
        columnsSettings[view].columnViewInfo[columnKey].hidden = !includes(
            enabledKeys,
            columnKey
        );
    });

    return columnsSettings;
}

export function getGoalsVisibilitySettings(
    settings: GoalDecl[],
    enabledKeys: string[]
): GoalDecl[] {
    const goalsSettings = cloneDeep(settings);

    goalsSettings.forEach(goalSetting => {
        goalSetting.hidden = !includes(enabledKeys, goalSetting.key);
    });

    return goalsSettings;
}

export function getGoalsSettingsWithUpdatedOrder(
    settings: GoalDecl[],
    columnOrder: string[]
): GoalDecl[] {
    return arrangeInOrder(settings, columnOrder);
}

export function getColumnSettingsWithUpdatedOrder(
    settings: ColumnsSettingsViewDict,
    columnOrder: string[],
    view: string
): ColumnsSettingsViewDict {
    if (!settings[view].columnOrder) {
        throw `No column settings for ${view}`;
    }

    return {
        ...settings,
        [view]: {
            ...settings[view],
            columnOrder
        }
    };
}

export function getColumnsWidthSettings(
    columnsSettings: ColumnsSettingsViewDict,
    key: string,
    width: number,
    view: string,
    isCompactViewEnabled: boolean
): ColumnsSettingsViewDict {
    if (!columnsSettings[view]) {
        throw `No column settings for ${view}`;
    }

    if (
        isCompactViewEnabled &&
        columnsSettings[view].columnViewInfo[key].widthCompact
    ) {
        columnsSettings[view].columnViewInfo[key].widthCompact = width;
    } else {
        columnsSettings[view].columnViewInfo[key].width = width;
    }

    return columnsSettings;
}
